import Link from 'next/link';

import Button from 'components/Button';
import { Heading } from 'components/Heading';

import { useBnplPromo } from 'hooks/bnpl/useBnplPromo';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import { BuyNowPayLaterPromo } from 'routes/invoices/components/BuyNowPayLaterPromo/BuyNowPayLaterPromo';
import { PackageItem } from 'routes/packages/types';

import { getBnplUnitPriceFromStringDollars } from 'utils/bnplUtils';

import s from './ClassicPackages.module.css';

export const ClassicPackages = ({
  packageList,
}: {
  packageList: PackageItem[];
}) => {
  const { isEnabled, bnplCapabilities } = useBnplPromo();
  const { theme } = useGGTheme();
  const promoTextColor = theme?.palette.textSecondary as string;
  const promoBackgroundColor = '#fff';

  return (
    <div>
      <Heading className={s.pageTitle}>Packages</Heading>
      <div className={s.list}>
        <p className={s.description}>
          <b>Already have a package?</b> Book as usual on our{' '}
          <Link href="/services">Services page</Link> — your credits will apply
          automatically at checkout.
          <br /> Coming soon, you&apos;ll be able to purchase your packages
          directly from this website.
        </p>
        {packageList.map((packageItem) => {
          const bnplUnitPrice = isEnabled
            ? getBnplUnitPriceFromStringDollars(packageItem.price)
            : undefined;

          return (
            <article key={packageItem.token} className={s.listItem}>
              <div className={s.main}>
                <h3 className={s.title}>{packageItem.name}</h3>
                <p>{packageItem.description}</p>
                <ul className={s.items}>
                  {packageItem.items.map((item) => (
                    <li key={item.token}>
                      {item.quantity}x {item.name}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={s.priceContainer}>
                <p className={s.details}>
                  {packageItem.price} {bnplUnitPrice ? 'or' : null}
                </p>
                {bnplUnitPrice ? (
                  <div className={s.bnplEligible}>
                    <BuyNowPayLaterPromo
                      unitAmount={bnplUnitPrice}
                      textAlign="right"
                      textColor={promoTextColor}
                      backgroundColor={promoBackgroundColor}
                      paymentMethodTypes={bnplCapabilities}
                    />
                  </div>
                ) : null}
              </div>
              <Button to="/contact" className={s.actionButton}>
                Contact to purchase
              </Button>
            </article>
          );
        })}
      </div>
    </div>
  );
};
